'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareThreadHistoryResponse = undefined;

var _buildResolvedAttachmentsMapFromResponse = require('../../resolved-attachments/operators/buildResolvedAttachmentsMapFromResponse');

var _buildThreadHistoryFromResponse = require('./buildThreadHistoryFromResponse');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var prepareThreadHistoryResponse = exports.prepareThreadHistoryResponse = function prepareThreadHistoryResponse(_ref) {
  var attachments = _ref.attachments,
      threadHistory = _objectWithoutProperties(_ref, ['attachments']);

  return {
    files: (0, _buildResolvedAttachmentsMapFromResponse.buildResolvedAttachmentsMapFromResponse)(attachments.files),
    threadHistory: (0, _buildThreadHistoryFromResponse.buildThreadHistoryFromResponse)(threadHistory)
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/operators/prepareThreadHistoryResponse.js
// module id = 640
// module chunks = 2 3